export default __webpack_public_path__ + "assets/json/development.aa6cc9.json";